import React, { Component } from 'react';
import { FiAlertTriangle } from 'react-icons/fi'
import { MdNavigateBefore, MdNavigateNext } from 'react-icons/md';
import { connect } from 'react-redux';
import { objectsConstants as OC } from 'redux/constant/objects-constant';
import { Card } from "components/Card/Card.jsx";
import { helperFunctions as HF } from '../../../helper/helperFunctions';
import {
    Grid,
    Row,
    Col,
    OverlayTrigger,
    Popover,
} from "react-bootstrap";
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { withRouter } from 'react-router-dom';
import OrderAttributeForm from './OrderAttributeForm';
import ToggleButton from "react-toggle-button";
import { confirmAlert } from 'react-confirm-alert';
import Confirmalertfordelete from '../../ThemeComponents/confirmAlertForDelete';
import { themeCSSConstants } from 'redux/constant/themeCSS';
import { brandActions } from '../../../redux/actions/brand-actions';
let _ = require('lodash');
var cloneDeep = require('lodash.clonedeep');
const DragHandle = SortableHandle(() => <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Click and Hold to Drag</Popover>}><span className="moveIcon orderDetailsAction"></span></OverlayTrigger>);
const SortableItem = SortableElement(({ value, onInputHandler, deleteConfirmListItem, onCheckFlag, adjustable_array, view_mode }) => (

    <tr test1={`innerItem-${value.key}`} key={`innerItem-${value.key}`} >

        <td>{value.key + 1}</td>
        <td>{value.value['title']}</td>
        <td>{value.value['cart_label']}</td>
        <td>{value.value['sample_value']}</td>
        <td>
            <select
                className="form-control"
                onChange={(e) => onInputHandler(e, value.key)}
                name='data_type'
                value={value.value['data_type'] ? value.value['data_type'] : ""}
                disabled={view_mode}
            >
                <option value="" disabled hidden>Choose Attribute</option>
                {
                    OC.dataTypeList.map((value, index) => (
                        <option value={value.value} key={index} > {value.label} </option>
                    ))
                }
            </select>
        </td>

        <td className="text-center">
            <div style={{ display: "inline-block" }}>
                <span className={view_mode ? 'disabledToggle' : ''}>
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={value.value['show_on_cart']}
                        name="show_on_cart"
                        onToggle={(e) => onCheckFlag(e, value.key, 'show_on_cart')}
                    />
                </span>
            </div>
        </td>
        <td className="text-center">
            <div style={{ display: "inline-block" }}>
                <span className={view_mode ? 'disabledToggle' : ''}>
                    <ToggleButton
                        inactiveLabel={''}
                        activeLabel={''}
                        colors={themeCSSConstants.THUMBICONSTYLE}
                        trackStyle={themeCSSConstants.TRACKSTYLE}
                        thumbStyle={themeCSSConstants.THUMBSTYLE}
                        thumbAnimateRange={[4, 30]}
                        value={value.value['is_quantity_attribute']}
                        onToggle={(e) => onCheckFlag(e, value.key, 'is_quantity_attribute')}
                        name="is_quantity_attribute"
                    />
                </span>
            </div>
        </td>

        <td>
            {
                adjustable_array.length > 0 && value.value['is_quantity_attribute'] === true ?
                    <React.Fragment>
                        <div className="flexElem alignCenter">
                            {
                                value.value['adjust_product_attribute'] === "" &&
                                <FiAlertTriangle className="text-sm mr-sm text-warning" />
                            }
                            <select
                                className="form-control text-capitalize"
                                onChange={(e) => onInputHandler(e, value.key)}
                                name='adjust_product_attribute'
                                value={value.value['adjust_product_attribute'] ? value.value['adjust_product_attribute'] : ""}
                                disabled={view_mode}
                            >
                                <option value="" disabled hidden>Choose Attribute</option>
                                {
                                    adjustable_array.map((data, index) => (
                                        <option value={data.id ? data.id : data.value} key={index} className="text-capitalize" > {data.label} </option>
                                    ))
                                }
                            </select>
                        </div>
                    </React.Fragment>
                    :
                    null
            }
        </td>
        <td>
            <DragHandle />
            <OverlayTrigger placement="bottom" overlay={<Popover id="tooltip">Delete Row</Popover>}>
                <span>
                    <button
                        onClick={() => { deleteConfirmListItem(value.key) }}
                        className="deleteIcon orderDetailsAction"
                        disabled={view_mode}
                    >&nbsp;</button>
                </span>
            </OverlayTrigger>
        </td>
    </tr>
));

const SortableList = SortableContainer(({ sortable, setSortable, brandOrderAttributes, onInputHandler, deleteConfirmListItem, onCheckFlag, adjustable_array, view_mode }) => {
    return (
        <tbody>
            {
                brandOrderAttributes.map((value, index) => (

                    <SortableItem
                        key={`item-${index}`}
                        index={index}
                        value={{ value: value, key: index }}
                        test={`item-${index}`}
                        onInputHandler={onInputHandler}
                        deleteConfirmListItem={deleteConfirmListItem}
                        onCheckFlag={onCheckFlag}
                        adjustable_array={adjustable_array}
                        view_mode={view_mode}
                        disabled={view_mode}
                    />

                ))
            }

        </tbody>
    );
});
class BrandOrderDefinition extends Component {

    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
        this.state = {
            addModal: false,
            brand: {
                brand_id: ''
            },
            brand_order_attributes: this.props.fetchedOrderAttributes ?
                this.props.fetchedOrderAttributes.order_attributes.length > 0 ?
                    this.props.fetchedOrderAttributes.order_attributes :
                    [{ ...OC.brand_order_attribute_default }] :
                [{ ...OC.brand_order_attribute_default }],

            type: this.props.fetchedOrderAttributes ? 'edit' : '',
            fetchedOrderAttributesAdded: this.props.fetchedOrderAttributes ? this.props.fetchedOrderAttributes.order_attributes_added : -1,
            adjustable_array: [],
            orderAdded: false,
            isChanged: false,
            order_attributes_added: this.props.fetchedOrderAttributes ? this.props.fetchedOrderAttributes.order_attributes_added : '',
            getChildState: false,
        }
    }

    setSortable = () => {
        this.setState({
            sortable: !this.state.sortable
        });
    }

    onSortEnd = ({ oldIndex, newIndex }) => {
        this.setState(({ brand_order_attributes }) => ({
            brand_order_attributes: arrayMove(brand_order_attributes, oldIndex, newIndex),
        }));
    };

    handleCheckStatus = (rowIndex, e) => {
        const { name, checked } = e.target;
        const atts = [...this.state.brand_order_attributes];
        const myObj = atts[rowIndex];
        myObj[name] = checked;
        this.setState({
            brand_order_attributes: atts
        })
    }
    onInputHandler = (e, rowIndex) => {
        const atts = cloneDeep(this.state.brand_order_attributes);
        if (e.target.type === 'text' || e.target.type === 'select-one') {
            const { name, value } = e.target;
            atts[rowIndex][name] = value;
        }
        else if (e.target.type === 'checkbox') {
            const { name, checked } = e.target;
            atts[rowIndex][name] = checked;
        }
        this.setState({ brand_order_attributes: atts });
    }

    onCheckFlag = (toggle, rowIndex, name) => {
        const atts = cloneDeep(this.state.brand_order_attributes);
        atts[rowIndex][name] = !toggle;
        this.setState({ brand_order_attributes: atts });
    }

    handleChangeState = (selectedOption, name) => {
        if (name.action === 'select-option') {
            this.setState({
                list: {
                    ...this.state.list,
                    parent_id: selectedOption.value,
                    parent: selectedOption.label
                }
            })
        }
    }

    handleAttributeSubmitForm = (data, formType) => {
        if (formType === 'add') {
            this.setState({
                brand_order_attributes: [
                    ...this.state.brand_order_attributes,
                    data
                ],
                getChildState: false,
            }, () => {

            })
        }
    }

    deleteConfirmListItem = (id) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <Confirmalertfordelete typeName="row" description={"Are you sure to delete this row"} onClosePro={onClose} deleteType={() => this.onDeleteAttribute(id)} />
                )
            }
        })
    }
    onDeleteAttribute = (key) => {
        const newAtts = this.state.brand_order_attributes.filter((data, index) => {
            return index !== key
        })
        this.setState({
            brand_order_attributes: newAtts
        })
    }
    onAttributesSubmit = () => {
        this.setState({
            isChanged: false,
        })
        let obj;
        obj = {
            attributes_type: 'order',
            brand_attributes: [...this.state.brand_order_attributes],
            _method: 'put',
        }
        this.props.storeBrandDataDefinitionCall(obj, this.props.storedBrand.id).then(res => {
            this.props.orderAttsHandler(res.result.data_definition);
            this.setState({
                orderAdded: true,
            });
        })
    }

    componentDidMount() {
        if (this.state.type === 'edit') {
            let newArray = [];
            this.props.fetchedOrderAttributes.product_attributes.forEach(data => {
                if (data.is_quantity_attribute === true) {
                    newArray.push({
                        id: !this.props.view_mode ? data.id : null,
                        label: data.title,
                        value: data.db_column,
                    })
                }
            })
            this.setState({
                adjustable_array: newArray
            })
        }
        if (this.props.fetchedOrderAttributes) {
            if (this.props.fetchedOrderAttributes.order_attributes_added == 0) {
                this.setState({
                    isChanged: true
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.productAtts !== prevProps.productAtts && this.props.productAtts !== []) {
            let newArray = [];
            this.props.productAtts.forEach(data => {
                if (data.is_quantity_attribute === true) {
                    newArray.push({
                        id: !this.props.view_mode ? data.id : null,
                        label: data.title,
                        value: data.db_column,
                    })
                }
            })
            this.setState({
                adjustable_array: newArray
            }, () => {
                if (this.state.brand_order_attributes.length === 1) {
                    this.setState({
                        brand_order_attributes: [{ ...OC.brand_order_attribute_default, adjust_product_attribute: this.state.adjustable_array.length > 0 ? this.state.adjustable_array[0].value : '' }]
                    })
                }
            });

        }
        if (this.props.quantityLength.length !== prevProps.quantityLength.length || this.props.productAtts.length !== prevProps.productAtts.length) {
            const newArray = this.state.brand_order_attributes.map(element => {
                return {
                    ...element,
                    adjust_product_attribute: this.state.adjustable_array.length > 0 ? this.state.adjustable_array[0].value : ''
                }
            })
            this.setState({
                brand_order_attributes: [
                    ...newArray
                ]
            })
        }

        if (!_.isEqual(this.state.brand_order_attributes, prevState.brand_order_attributes)) {
            this.setState({
                isChanged: true
            })
        }

        if (this.props.complete_definition !== prevProps.complete_definition) {
            if (this.props.complete_definition.order_attributes_added == 0) {
                this.setState({
                    isChanged: true
                })
            }
        }

    }

    render() {
        const { brand_order_attributes } = this.state;
        const { view_mode } = this.props;
        return (
            <div>
                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                ctTableResponsive
                                content={
                                    <div>
                                        <Grid fluid>
                                            <Row>
                                                <Col md={12}>
                                                    <h3 style={{ textAlign: 'center', fontWeight: "500" }}>Order Data Definition</h3>
                                                    <div>Please use the Add Attribute button to create an attributeto capture data as part of order definition. For example, Quantity Ordered, Sticker Quantity etc.</div>
                                                </Col>
                                                <Col md={12} className="mt-md">
                                                    <div className="table-responsive">
                                                        {

                                                            <table className="table theme_table blank table-striped mt-md" style={{ border: "1px solid #bebebe" }}>
                                                                <thead>
                                                                    <tr>

                                                                        <th>Order</th>
                                                                        <th>Title</th>
                                                                        <th>Cart Label</th>
                                                                        <th>Sample Value</th>
                                                                        <th>Data Type</th>
                                                                        <th className="text-center">Show On Cart</th>
                                                                        <th className="text-center">Qty Attribute</th>
                                                                        <th>Adjut Prod Attribute</th>
                                                                        <th>Control</th>
                                                                    </tr>
                                                                </thead>
                                                                <SortableList
                                                                    axis='y'
                                                                    helperClass="movingTr"
                                                                    brandOrderAttributes={this.state.brand_order_attributes}
                                                                    onSortEnd={this.onSortEnd}
                                                                    onInputHandler={this.onInputHandler} deleteConfirmListItem={this.deleteConfirmListItem}
                                                                    onCheckFlag={this.onCheckFlag}
                                                                    adjustable_array={this.state.adjustable_array}
                                                                    useDragHandle
                                                                    view_mode={this.props.view_mode}
                                                                />
                                                                {
                                                                    !view_mode &&
                                                                    <tbody>
                                                                        <OrderAttributeForm
                                                                            closeModel={HF.closeModal.bind(this, "addModal")}
                                                                            formTypePro="add"
                                                                            brandPro={OC.brand_order_attributes}
                                                                            handleSubmit={this.handleAttributeSubmitForm}
                                                                            name={this.props.title}
                                                                            componentPro={'Brand'}
                                                                            attributesProp={brand_order_attributes}
                                                                            adjustable_array={this.state.adjustable_array}
                                                                            listDataProp={this.state[this.props.title + '_data']}
                                                                            attributesLength={this.state.brand_order_attributes.length + 1}
                                                                            getChildState={this.state.getChildState}
                                                                        />
                                                                    </tbody>
                                                                }
                                                            </table>
                                                        }
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Grid>
                                        {/* Add Order Attribute */}
                                        {
                                            !view_mode &&
                                            <div className="text-center">
                                                {
                                                    !_.isEmpty(this.state.brand_order_attributes) &&
                                                    <button className="customBtn btnBlue m-sm " onClick={this.onAttributesSubmit} disabled={this.state.isChanged === true ? false : true}>Save Updates</button>
                                                }
                                            </div>
                                        }
                                    </div>
                                } />
                        </Col>
                    </Row>
                </Grid>
                {
                    !view_mode &&
                    <div className="stepsNav">

                        <div className="text-center">
                            <button onClick={this.props.previousStep} className="stepNav prev"><MdNavigateBefore /></button>
                            <span className="display_ib mt-xs">Prev</span>
                        </div>
                        {
                            this.state.orderAdded && this.props.complete_definition.order_attributes_added == 1 &&
                            <div className="text-center">
                                <button onClick={this.props.nextStep} className="stepNav next" disabled={this.state.isChanged === true ? true : false} ><MdNavigateNext /></button>
                                <span className="display_ib mt-xs">Next</span>
                            </div>
                        }

                        {
                            this.state.type === 'edit' && this.state.brand_order_attributes.length > 0 && !this.state.orderAdded && this.state.order_attributes_added == 1 &&
                            <div className="text-center">
                                <button onClick={this.props.nextStep} className="stepNav next" disabled={this.state.isChanged === true ? true : false} ><MdNavigateNext /></button>
                                <span className="display_ib mt-xs">Next</span>
                            </div>
                        }
                    </div>
                }
                {
                    view_mode &&
                    <div className="stepsNav">
                        <div className="text-center">
                            <button onClick={this.props.previousStep} className="stepNav prev"><MdNavigateBefore /></button>
                            <span className="display_ib mt-xs">Prev</span>
                        </div>
                        <div className="text-center">
                            <button onClick={this.props.nextStep} className="stepNav next"><MdNavigateNext /></button>
                            <span className="display_ib mt-xs">Next</span>
                        </div>
                    </div>
                }
                {
                    view_mode &&
                    <div className="text-center">
                        <button
                            className="customBtn btnBlue m-md"
                            type='button'
                            onClick={() => { this.props.history.goBack() }}
                        >Go Back</button>
                    </div>
                }
            </div>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return ({
        storeBrandCall: (brandData) => { return dispatch(brandActions.storeBrand(brandData)) },
        storeBrandOrderAttsCall: (brandData, id) => { return dispatch(brandActions.storeBrandOrderAtts(brandData, id)) },
        storeBrandDataDefinitionCall: (data, id) => { return dispatch(brandActions.storeBrandDataDefinition(data, id)) }

    });
};
function mapStateToProps(state, ownProps) {
    const { brand } = state.brandReducer;
    return {
        brand,
    };
}

const BrandOrder = withRouter(connect(mapStateToProps, mapDispatchToProps)(BrandOrderDefinition));
export default BrandOrder;


// WEBPACK FOOTER //
// ./src/components/Admin/Brands/BrandOrder.jsx